import {Inject, Injectable} from "ng-metadata/core";
import {MappingTablesCache} from "../../../mappingTablesCache/mappingTablesCache.service";
import {getFeatureFlags, getVid, getDirectLoginTransferAllParameters} from "../../../appConfig/appConfigForward";
import {STATE_NAMES} from "../../../primoExplore/primoExploreStates.module";
import {UserSessionManagerService} from "../../userSessionManager.service";
import {FullViewPageService} from "../../../search/fullView/fullViewPage/fullViewPage.service";

const get = require('lodash/get');
const _clone = require('lodash/clone');
@Injectable()
export class DirectLoginService {
    constructor(
        private userSessionManagerService : UserSessionManagerService,
        @Inject('$translate') private $translate,
        @Inject('$state') private $state : ng.ui.IStateService,
        @Inject('$window') private $window: ng.IWindowService,
        private mappingTablesCache: MappingTablesCache,
        private fullViewPageService :FullViewPageService) {

    }

    public  isDirectLoginEnabled() : boolean {
        var featureFlags = getFeatureFlags();
        if(!get(featureFlags, 'direct_login', false))
            return false;
        return this.mappingTablesCache.findByProperties('View Properties', {
            source1: getVid(),
            source2: 'allow_direct_login_from_other_institutions',
            target: 'true'
        }).length !== 0;
    }

    public getRecordLinkedId(institutionCode : String , docid:  String  ) : String {

        //Check if alma record 
        if (!docid.startsWith('alma')){
            return null ;
        }
        //Get the value of the current Item from overlay or full view
        let currentItem = this.fullViewPageService.currentItem ;
        if (currentItem){
            let almaInstitutionList = get(currentItem , 'delivery.almaInstitutionsList' , []);
            if (almaInstitutionList){
                  let almaInstitution = almaInstitutionList.filter(e1 => { return String(e1.instCode) == institutionCode})[0] ;
                  if ( almaInstitution != null){
                    let linkRecordId =  get(almaInstitution , 'getitLink[0].linkRecordId');
                    //add Alma Prefix
                    linkRecordId = "alma" + linkRecordId;
                    return linkRecordId ;
                  }
            }
        }
        return null ;       
    }


    async getDirectLinksList(state: object) {
        if (!this.isDirectLoginEnabled()){
            return [];
        }
        const directLoginConfig = this.mappingTablesCache.getTable('Prima Direct Login To Other Institutions');
        return Promise.all(directLoginConfig.map((config) => {
            return this.$translate(`institutionLabel.DirectLogin.${config.source4}`).then((name)=> {
                const viewId = `${config.source1}:${config.source3}`;
                let toParams = get(state, 'toParams', _clone(this.$state.params)) ;
                let toState  =  get(state, 'toState', this.$state.current.name ) ;
                if (toState == "fulldisplay"){
                    let recordLinkedId =this.getRecordLinkedId(config.source1 , toParams.docid );
                    if (recordLinkedId){
                        toParams.docid = recordLinkedId ;
                    }
                }
                toParams.vid = viewId;
                if(getDirectLoginTransferAllParameters()) {
	        			let href = this.$state.href(STATE_NAMES.LOGIN, {vid: viewId, lang: toParams.lang,
                    		toState: toState , toParams: JSON.stringify(toParams)});
                    		return { name: name , link: `${config.source2}${href}`};
				}
                else return { name: name , link: `${config.source2}/discovery/login?vid=${viewId}`};
            });
        }));
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/components/security/login/unionCatalogLogin/directLogin.service.ts